import { getYears } from "./time";

export interface IEntryBenefits {
    daily_salary: number;
    yearly_salary: number;
    vacations: number;
    vacations_bonus: number;
    easter_royalty: number;
    first_bonus: number;
    second_bonus: number;
    bonus: number;
    afp_retention: number;
    sfs_retention: number;
    contribution_retention: number;
    afp_payment: number;
    sfs_payment: number;
    arl_payment: number;
    infotep_payment: number;
    contribution_payment: number;
    tss_payment: number;
}

// Every benefit is a function of the monthly salary and the seniority the
// employee has on the report date, so it has to be recomputed whenever either
// of those changes — not only when the salary is typed.
export const computeEntryBenefits = (
    salary: number,
    reportDate: Date | null,
    joinDate: Date | null | undefined,
): IEntryBenefits => {
    const years = getYears(reportDate, joinDate ?? null);
    const dailySalary = salary / 23.83;

    const vacations = years >= 5 ? dailySalary * 18 : years >= 1 ? dailySalary * 14 : 0;
    const vacationsValue = vacations / 23.83;

    let vacationsBonus = 0;
    if (years >= 15) vacationsBonus = salary * 0.5;
    else if (years >= 9) vacationsBonus = salary * 0.4166;
    else if (years >= 4) vacationsBonus = salary * 0.3333;
    else if (years >= 1) vacationsBonus = salary * 0.25;

    const firstBonus = years < 1 ? 0 : years > 3 ? dailySalary * 60 : dailySalary * 45;
    const secondBonus = (years < 1 ? 0 : years >= 3 ? vacationsValue * 60 : vacationsValue * 45) / 12;

    return {
        daily_salary: dailySalary,
        yearly_salary: salary * 12,
        vacations,
        vacations_bonus: vacationsBonus,
        easter_royalty: years >= 1 ? salary : salary * years,
        first_bonus: firstBonus,
        second_bonus: secondBonus,
        bonus: firstBonus + secondBonus,
        afp_retention: salary * 0.0287,
        sfs_retention: salary * 0.0304,
        contribution_retention: salary * 0.0591,
        afp_payment: salary * 0.071,
        sfs_payment: salary * 0.0709,
        arl_payment: salary * 0.011,
        infotep_payment: salary * 0.01,
        contribution_payment: salary * 0.1629,
        tss_payment: salary * 0.222,
    };
};
